import { Injectable } from '@angular/core';
import { MatSnackBar } from "@angular/material/snack-bar";
import {MatDialog} from "@angular/material/dialog";
import { NewellPrompterComponent } from "./prompter/prompter.component";

@Injectable({ providedIn: 'root' })
export class NewellAlert {

  private PROMPTER_WIDTH = '400px';

  constructor(private _snackBar: MatSnackBar,
              private _dialog: MatDialog) { }

  public toast(message: string, action?: string, config?: any) {
    config = {
      verticalPosition: 'top',
      horizontalPosition: 'right',
      duration: 5000,
    };
    this._snackBar.open(message, action, config);
  }

  public prompt(config) {
    const that = this;
    const dialogRef = this._dialog.open(NewellPrompterComponent, {
      width: that.PROMPTER_WIDTH,
      data: config,
    });

    return dialogRef.afterClosed();
  }
}
